import React from "react";
import PlaceCard from "../../common/PlaceCard";
import img1 from "../../../assets/img/Home/card-cover.png";
import img2 from "../../../assets/img/Home/Rectangle 23.png";
import img3 from "../../../assets/img/Home/Rectangle 25.png";
const CategoriesSec = ({inforesidence}) => {
  console.log("catsec",inforesidence)

  return (
   <div className="">
      <div className="container">
      <div className="grid grid-cols-4 gap-[36px] CategoriesSec">
      {inforesidence.map(i=> <PlaceCard 
      key={i.id}
      id={i.id}
      slug={i.slug}
      code={i.code}
      img={`${i.thumbnail.path}`}
      isfast={i.instant_reserve === 1? true:false}
      rate={i.rating_value}
      info={i.address}
      title={i.title}
      cost={i.price}
      tip={i.special_discount_in_24}
      room={i.rooms_count}
      city={i.city}
      type={i.type}
        />)}
      
      </div>
    </div>
   </div>
  );
};

export default CategoriesSec;
